'use client';

const LATEST_LAUNCH = {
  name: 'Fetti',
  description: 'Money tracker for cash workers: shift logs, receipt OCR, tax math. Live.',
  domain: 'fetti.tips',
  color: '#f59e0b', // --bag-amber
} as const;

export function CurrentlyBuilding() {
  return (
    <a
      data-currently-building
      href={`https://${LATEST_LAUNCH.domain}`}
      target="_blank"
      rel="noopener noreferrer"
      className="group block mt-12 w-full max-w-[420px] transition-all duration-300"
      style={{
        background: 'var(--bg-elevated)',
        border: '1px solid var(--border)',
        borderLeft: `3px solid ${LATEST_LAUNCH.color}`,
        borderRadius: 'var(--radius-lg)',
        padding: '16px 20px',
        animation: 'fade-up 0.8s cubic-bezier(0.16, 1, 0.3, 1) 1.3s both',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--border-hover)';
        e.currentTarget.style.borderLeftColor = LATEST_LAUNCH.color;
        e.currentTarget.style.boxShadow = 'var(--shadow-glow)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--border)';
        e.currentTarget.style.borderLeftColor = LATEST_LAUNCH.color;
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div
        className="font-mono text-text-muted"
        style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.12em' }}
      >
        LATEST LAUNCH
      </div>
      <div className="mt-1.5 flex items-baseline justify-between gap-3">
        <span className="font-sans text-text" style={{ fontSize: 16, fontWeight: 700 }}>
          {LATEST_LAUNCH.name}
        </span>
        <span className="font-mono text-accent" style={{ fontSize: 11 }}>
          {LATEST_LAUNCH.domain}
        </span>
      </div>
      <p className="mt-1 text-text-secondary" style={{ fontSize: 13, lineHeight: 1.5 }}>
        {LATEST_LAUNCH.description}
      </p>
    </a>
  );
}
